'use strict';
angular.module('resourceCenterMaterialModule').directive('searchBar', [
    'materialConst',
    function(materialConst) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './resourceCenter/materialResource/directive/initSearchBar/index.html',
            replace: true,
            transclude: {
                expand: 'expand', // 展开按钮
            },
            link: function($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description] 初始化状态
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    $scope.data = {
                        fromdate: '', // 开始时间
                        untildate: '', // 结束时间
                        keywords: '', // 关键字搜索
                        sourceList: [], // 来源列表
                        selectedSource: {}, // 选中的来源对象
                        keywordsTypeList: [],
                        selectedKeywordsType: {},
                    };
                }

                /**
                 * [initData description] 初始化数据
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    $scope.data.sourceList = materialConst.sourceList[0];
                    $scope.data.selectedSource = $scope.data.sourceList[0];
                    $scope.data.keywordsTypeList = materialConst.keywordsTypeList;
                    $scope.data.selectedKeywordsType = $scope.data.keywordsTypeList[0];
                }

                /**
                 * [search description] 搜索回调函数
                 * @param   {[type]}  type  [type description] 搜索类型
                 * @param   {[type]}  ev  [type description] 事件触发对象
                 * @return  {[type]}        [return description]
                 */
                $scope.search = function(type, ev) {
                    if ((angular.isDefined(ev) && ev.keyCode === 13) || angular.isUndefined(ev)) {
                        switch (type) {
                            case 'time': {
                                $scope.basicalStatus.searchParams.customStartTime = $scope.data.fromdate;
                                $scope.basicalStatus.searchParams.customEndTime = $scope.data.untildate;
                                if ($scope.data.fromdate && $scope.data.untildate) {
                                    $scope.basicalStatus.searchParams.uploadTime = 'custom'; // 目前只有自定义时间
                                } else {
                                    delete $scope.basicalStatus.searchParams.uploadTime;
                                }
                                break;
                            }
                            case 'source': {
                                if ($scope.data.sourceList[0]) {
                                    $scope.basicalStatus.searchParams.sourceType = $scope.data.sourceList[0][0].value;
                                    if ($scope.data.sourceList[0][1]) {
                                        $scope.basicalStatus.searchParams.section = $scope.data.sourceList[0][1].value;
                                    } else {
                                        delete $scope.basicalStatus.searchParams.section;
                                    }
                                } else {
                                    return;
                                }
                                break;
                            }
                        }
                        $scope.basicalStatus.searchParams.pageNum = $scope.page.CURRPAGE = 1;
                        $scope.basicalStatus.isWithFilters = true;
                        $scope.requestData();
                    }
                };

                $scope.showSelectedArea = function(node) {
                    if (!angular.isDefined(node.value)) {
                        return Promise.resolve(materialConst.sourceList);
                    } else if (node.value === 'product') {
                        return Promise.resolve(materialConst.channels);
                    } else {
                        return Promise.resolve([]);
                    }
                };
            },
        };
    },
]);
